import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { BaseButton, Sidebar } from "@velocity-ehs/component-library";
import { Input } from "../../sharedComponents/inputs/Input";
import { useTranslation } from "react-i18next";

interface Props {
  showSlider: boolean;
  closeSliderCallback: () => void;
  addOrgUnit: (name: string) => void;
}

const AddOrgUnitSlider: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    reset,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm<{ name: string }>({
    mode: "onBlur",
  });

  const handleAddOrgUnit = async () => {
    const { name } = getValues();
    await props.addOrgUnit(name);
  };

  useEffect(() => {
    reset();
    // eslint-disable-next-line
  }, [props.showSlider]);

  const content = (
    <form id="addOrgUnitForm" onSubmit={handleSubmit(handleAddOrgUnit)}>
      <Input
        control={control}
        name="name"
        label={t("universal_Name")}
        rules={{
          required: t("customer_Form_Name_Required"),
          pattern: {
            value: /^\s*[^>]+\s*$/i,
            message: `${t("message_name_cannot_contain")} >.`,
          },
          maxLength: {
            value: 25,
            message: t("hierarchies_Add_Org_Unit_Name_Max_Length_Validation"),
          },
        }}
        errorMessage={errors ? errors.name?.message : undefined}
      />
    </form>
  );

  const footerButtons = () => {
    return (
      <BaseButton
        type="submit"
        label={t("universal_Add")}
        form="addOrgUnitForm"
        loading={isSubmitting}
      />
    );
  };

  return (
    <Sidebar
      header={t("action_add_org_unit")}
      visible={props.showSlider}
      onHide={props.closeSliderCallback}
      footer={footerButtons()}
    >
      {content}
    </Sidebar>
  );
};

export default AddOrgUnitSlider;
